module.exports = __webpack_public_path__ + "assets/img/Sunset Way.98efbdfe.jpg";